import { useState } from 'react'

import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'

import { queryClient } from '@shared/providers/src/QueryClientProvider'
import { handleError, QK, TaskKind, TaskStatus, UserRole } from '@shared/utils'

import { NewTaskDialog, useStatusChangeConfirmation } from '@components/Kanban'

import { useTasksFilters } from '../../Tasks.hooks'
import { useMarkExpired } from './TaskInfo.hooks'
import { isNotDone } from './TaskInfo.utils'

export default function CreateQLinkRequestInfo({ data, patient }) {
  const [open, setOpen] = useState(false)
  const [, updateFilters] = useTasksFilters()
  const markExpired = useMarkExpired(data.id)
  const requestStatusChange = useStatusChangeConfirmation({ provider: true })

  // Once the task is resolved, there's nothing left for the provider to do here.
  if (!isNotDone(data)) return null

  // BE auto-resolves this provider task once the related Qlink Lab task is created,
  // so refresh the board and clear the now-completed task from the detail pane.
  const handleSuccess = () => {
    queryClient.invalidateQueries({ queryKey: QK.tasks.lists })
    updateFilters({ task: undefined })
  }

  // Expiring drops the task out of the provider's list, which is filtered to In Progress.
  const handleExpire = () => {
    requestStatusChange(data, TaskStatus.Expired, {
      onConfirm: (reason) =>
        markExpired
          .mutateAsync(reason)
          .then(() => updateFilters({ task: undefined }))
          .catch(handleError),
    })
  }

  return (
    <>
      <Stack direction="row" sx={{ justifyContent: 'flex-end', gap: 1 }}>
        <Button variant="outlined" onClick={handleExpire}>
          Expire
        </Button>
        <Button variant="contained" onClick={() => setOpen(true)}>
          Create Qlink Lab Task
        </Button>
      </Stack>
      <NewTaskDialog
        open={open}
        patient={patient}
        presetType={TaskKind.QLinkLab}
        relatedTaskId={data.id}
        title="Create Qlink Lab Task"
        assigneeRole={UserRole.MA}
        assigneeRequired
        hideMe
        onSuccess={handleSuccess}
        onClose={() => setOpen(false)}
      />
    </>
  )
}
